module.exports = require('./lib/tunnel');



//////////////////
// WEBPACK FOOTER
// ./~/tunnel/index.js
// module id = 2616
// module chunks = 0 1